import React from 'react';

interface IProps {
  fill?: string;
}

const BikeIcon: React.FC<IProps> = (props) => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 511.989 511.989" enableBackground="new 0 0 511.989 511.989">
<g>
	<g>
		<path fill={props.fill} d="M405.337,207.992c-9.734,0-19.171,1.312-28.155,3.773l-27.469-71.444l9.938-10.218c4.062-4.188,4.016-10.859-0.109-14.992
			l-21.328-21.32c-2-2-4.719-3.133-7.547-3.133h-53.326c-5.891,0-10.672,4.781-10.672,10.672s4.78,10.664,10.671,10.664h48.904
			l10.781,10.773l-7.375,7.562c-2.969,3.055-3.719,7.437-2.328,11.187c0,0.023,0.016,0.055,0.016,0.086l9.812,25.5l-145.153,18.141
			v-19.914h32c5.891,0,10.672-4.781,10.672-10.671s-4.781-10.664-10.672-10.664h-63.999c-5.891,0-10.664,4.773-10.664,10.664
			s4.773,10.671,10.664,10.671h10.671v29.109l-14.898,25.546c-14.711-7.656-31.406-11.992-49.101-11.992
			C47.858,207.992,0,255.843,0,314.645c0,58.844,47.858,106.686,106.67,106.686c51.515,0,94.607-36.717,104.521-85.342h14.64
			c4.406,12.422,16.257,21.344,30.171,21.344c17.648,0,31.991-14.344,31.991-32c0-7.375-2.499-14.186-6.718-19.592l68.326-106.28
			l7.672,19.984c-34.734,17.602-58.608,53.671-58.608,95.2c0,58.844,47.858,106.686,106.67,106.686
			c58.812,0,106.654-47.842,106.654-106.686C511.991,255.842,464.148,207.992,405.337,207.992z M106.671,399.988
			c-47.054,0-85.334-38.281-85.334-85.344c0-47.037,38.281-85.317,85.334-85.317c13.781,0,26.804,3.281,38.335,9.109l-47.554,81.521
			c-2.961,5.094-1.25,11.609,3.844,14.594c1.695,0.969,3.539,1.438,5.367,1.438c0,0,0.031,0,0.055,0h82.584
			C179.802,372.769,146.357,399.988,106.671,399.988z M125.241,314.644l37.499-64.263c17.922,15.656,29.257,38.672,29.257,64.263
			H125.241z M225.832,314.644h-12.5c0-33.466-15.499-63.38-39.694-82.95l7.695-13.203l50.257,86.155
			C229.113,307.584,227.145,310.958,225.832,314.644z M256.004,335.988c-5.891,0-10.672-4.797-10.672-10.656
			c0-5.906,4.781-10.688,10.672-10.688c5.883,0,10.664,4.781,10.664,10.688C266.668,331.191,261.887,335.988,256.004,335.988z
			 M263.34,294.177c-2.367-0.546-4.813-0.843-7.336-0.843c-2.055,0-4.055,0.188-5.984,0.562l-51.327-87.991l131.989-16.5
			L263.34,294.177z M405.337,399.988c-47.062,0-85.343-38.281-85.343-85.344c0-32.451,18.25-60.74,45-75.162l30.39,79.005
			c1.641,4.219,5.672,6.844,9.953,6.844c1.266,0,2.562-0.25,3.828-0.719c5.499-2.125,8.233-8.281,6.14-13.779l-30.42-79.03
			c6.562-1.617,13.421-2.477,20.452-2.477c47.046,0,85.326,38.28,85.326,85.317C490.663,361.707,452.383,399.988,405.337,399.988z"
			/>
	</g>
</g>
</svg>
);

export default BikeIcon;
